import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import { alterSiteDrawer } from '~/data/actions/siteActions'

export default function DuplicateLandingPage({ landingPage, onFinish = () => {} }) {
    const dispatch = useDispatch()
    const [creating, setCreating] = useState(false)
    const [newName, setNewName] = useState(landingPage.formName + ' - copy')
    const [error, setError] = useState('')

    const onConfirm = async () => {
        if (newName.length < 4) return setError('Required')
        setError('')
        setCreating(true)
        try {
            const res = await axios.post('/landingpage/' + landingPage.id + '/copy', {
                formName: newName
            })
            dispatch(alterSiteDrawer(false, false, 'right', null))
            onFinish(res.data.id)
        } catch (e) {
            setCreating(false)
            setError(e?.response?.data?.message || 'Failed to duplicate landing page')
        }
    }

    const onCancel = () => {
        dispatch(alterSiteDrawer(false, false, 'right', null))
    }

    return (
        <div>
            <h4 className='mar-b24'>Duplicate the {landingPage.formName} landing page?</h4>
            <TextInput
                outerClassName='mar-b24'
                label='New Landing Page Name'
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder='New Landing Page Name'
                error={error}
            />
            <div className='row'>
                <div className='col-xs-6'>
                    <Button
                        text='Duplicate'
                        disabled={creating}
                        className={'button-primary button-fullwidth'}
                        onClick={onConfirm}
                        iconLeft={<Icons icon='copyClipboard' />}
                    />
                </div>
                <div className='col-xs-6'>
                    <Button
                        className='button-fullwidth'
                        disabled={creating}
                        text={i18n.t('cancel')}
                        onClick={onCancel}
                    />
                </div>
            </div>
        </div>
    )
}
